import Link from "next/link";
import { Col, Container, Image, Row } from "react-bootstrap";
import { parseHtml } from "../../../utils/common";
import styles from "./style.module.scss";

const NextProject = ({ data }) => {
  return (
    <section
      className={`${styles["next-project-section"]} ${styles["next-technology-section"]} bg-one home-padding-new`}
    >
      <Container className={styles['container']}>
        <Row>
          <Col xl={5} lg={4} md={4}>
          <div className={`common-top ${styles["next-project-content"]}`}>
              <h2 className="text-black">{data?.Title}</h2>
              <h4>{data?.Subtitle}</h4>
              <p>{data?.Description}</p>
              <ul className={styles["next-project-list"]}>
                {data?.["key-points"]?.map((point) => (
                  <li key={point.id} className="text-normal font-medium text-black">
                    <Image
                      src="/images/home/next-right-green.svg"
                      alt="project-img"
                    />
                    {point?.title}
                  </li>
                ))}
              </ul>
              {data?.Button && (
                <Link href={data.Button.href} className="btn btn-primary">
                  {data.Button.label}
                </Link>
              )}
            </div>
          </Col>
          <Col xl={7} lg={8} md={8}>
            {data?.Card?.map((card) => (
              <div key={card.id} className={styles["next-project-card"]}>

                <div className={`font-regular text-normal ${styles["next-project-right-content"]}`}>
                  <h3 className="text-medium font-semibold text-black">{card.title}</h3>
                  {parseHtml(card.text)}
                </div>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NextProject;
